$( document ).ready(function() {
	
	$('a[data-hud-action="xfullscreen"]').click(function (e) {
		console.log('anim');
		$('.column-wrapper .column-right,.column-wrapper .column-left, .custom').fadeToggle(
			3000, function () {
				
			}
			
		);
	});
});